import { useTheme } from '@mui/material/styles';
import { Stack, Box, Button, Container, Typography, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const buttonStyles = ( from_atp, from_doktor, from_hellohealth, organization_id ) => {
  let backgroundColor, color;

  if ( from_atp ) {
    backgroundColor = theme => theme.palette.atp.main;
    color = 'white';
  } else if ( from_doktor ) {
    backgroundColor = theme => theme.palette.doktor.main;
    color = 'white';
  } else if ( from_hellohealth ) {
    backgroundColor = theme => theme.palette.hellohealth.main;
    color = 'white';
  } else if ( organization_id === 0 ) {
    backgroundColor = theme => theme.palette.primary.main;
    color = 'white';
  } else {
    backgroundColor = theme => theme.palette.primary.main;
    color = 'white';
  }

  return {
    mt: {
      xs: 2,
      sm: 4,
    },
    color,
    background: backgroundColor,
    '&:hover': {
      backgroundColor: backgroundColor,
      color: color,
    },
    borderRadius: 6,
    fontWeight: 600,
    width: {
      xs: '100%',
      sm: '300px',
    },
  };
};
/**
 * React functional component representing the Error Page.
 * @component
 * @returns {JSX.Element} The rendered ErrorPage component.
 */
export const ErrorPage = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery( theme.breakpoints.down( 'sm' ) );
  const navigate = useNavigate();


  // Helper function to get the correct navigation URL based on the landing URL
  const getNavigationUrl = ( landingUrl ) => {
    const navigationMap = {
      '/atpllanding': '/atpl-pre-face-scan',
      '/doktorlanding': '/doktor-pre-face-scan',
      '/hellohealth-landing?key=eFI4bVRfNUxqTmN6M1F5ZVUwZGJBazYxSG5Qb1Y0SzlzTTJ0Wnc3Z1hycWY=': '/hellohealth-pre-face-scan',
    };

    // Default to '/pre-face-scan' if no match found
    return navigationMap[ landingUrl ] || '/pre-face-scan';
  };

  const navigateToScan = () => {
    const landingUrl = localStorage.getItem( 'landing_url' ); // Get the landing URL from localStorage

    // Get the appropriate navigation URL using the helper function
    const urlToNavigate = getNavigationUrl( landingUrl );

    navigate( urlToNavigate, {
      state: {
        isFaceScanFailed: true, // muset send Bollean  state 
      },
    } );
  };

  const startNewAssessmentHandler = () => {
    const landingUrl = localStorage.getItem( 'landing_url' ) || '/symptom-checker'; // Default to '/symptom-checker' if not available

    // Navigate to the determined URL 
    navigate( landingUrl );
  };

  const from_atp = localStorage.getItem( 'from_atp' ) === 'true';
  const from_doktor = localStorage.getItem( 'from_doktor' ) === 'true';
  const from_hellohealth = localStorage.getItem( 'from_hellohealth' ) === 'true';
  const organization_id = parseInt( localStorage.getItem( 'organization_id' ) || '0' );

  return (
    <Container
      maxWidth="lg"
      sx={ {
        px: 4,
      } }
    >
      <Stack spacing={ 2 } alignItems="center" justifyContent="center" sx={ { height: '100vh' } }>
        <Typography
          variant="h4"
          sx={ {
            fontWeight: 600,
            textAlign: 'center',
            ...( isSmallScreen ? { fontSize: 15 } : {} ),
            mb: 3,
          } }
        >
          Face Scan Service Unavailable
        </Typography>
        <Typography variant="h6" sx={ { marginTop: 4, maxWidth: '800px', width: '80%' } } textAlign="center">
          We're sorry for any inconvenience, but our system is currently experiencing a high volume of users. Please
          consider trying again at a later time. Thank you for understanding!
        </Typography>
        <Box
          sx={ {
            py: 3,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            justifyContent: 'center',
            width: 1,
            gap: {
              xs: 0,
              sm: 2,
            },
          } }
        >
          <Button
            variant="contained"
            disableElevation
            size="large"
            sx={ buttonStyles( from_atp, from_doktor, from_hellohealth, organization_id ) }
            onClick={ navigateToScan }
          >
            Retry a face scan assessment
          </Button>
          <Button
            onClick={ startNewAssessmentHandler }
            variant="contained"
            disableElevation
            size="large"
            sx={ buttonStyles( from_atp, from_doktor, from_hellohealth, organization_id ) }
          >
            Start a new assessment
          </Button>
        </Box>
      </Stack>
    </Container>
  );
};
